/*
  Inline variant "pill" selector used on product cards, shop-the-look, and
  anywhere with individual / combined add-to-cart buttons.

  Markup contract (rendered by snippets/variant-pills.liquid + host templates):
    [data-vpills-scope]            wraps ONE product (its pills + its ATC)
      <variant-pills>              holds the chosen variant id (multi-variant only)
      [data-vpills-add]            individual ATC; for single-variant products it
                                   carries data-variant-id directly
    [data-vpills-all-scope]        wraps several product scopes
      [data-vpills-add-all]        combined "add all" button
*/
class VariantPills extends HTMLElement {
  constructor() {
    super();
    this._selected = null;
    this.addEventListener("click", (e) => {
      const pill = e.target.closest(".vpill");
      if (!pill || pill.hasAttribute("disabled")) return;
      this.select(pill.dataset.variantId, pill);
    });
  }
  select(id, pillEl) {
    this._selected = id;
    this.querySelectorAll(".vpill").forEach((p) =>
      p.classList.toggle("is-active", p === pillEl)
    );
    this.classList.remove("vpills--error");
    // Reflect the choice on the paired individual ATC (label + enabled state)
    const scope = this.closest("[data-vpills-scope]");
    const btn = scope && scope.querySelector("[data-vpills-add]");
    if (btn) {
      btn.removeAttribute("disabled");
      if (btn.dataset.addLabel) {
        const span = btn.querySelector("[data-vpills-label]") || btn;
        span.textContent = btn.dataset.addLabel;
      }
    }
    this.dispatchEvent(
      new CustomEvent("vpills:change", { bubbles: true, detail: { variantId: id } })
    );
  }
  get variantId() {
    return this._selected;
  }
  flashError() {
    this.classList.add("vpills--error");
  }
}
if (!customElements.get("variant-pills")) {
  customElements.define("variant-pills", VariantPills);
}

(function () {
  function cart() {
    return document.querySelector("cart-container");
  }
  function toast(msg) {
    document.querySelectorAll(".vpills-toast").forEach((t) => t.remove());
    const t = document.createElement("div");
    t.className = "vpills-toast";
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(() => t.classList.add("is-visible"));
    setTimeout(() => {
      t.classList.remove("is-visible");
      setTimeout(() => t.remove(), 300);
    }, 2600);
  }
  function itemFromScope(scope, missing) {
    const vp = scope.querySelector("variant-pills");
    if (vp) {
      if (!vp.variantId) {
        if (missing) missing.push(vp);
        return null;
      }
      return { id: parseInt(vp.variantId, 10), quantity: 1 };
    }
    // Single-variant product: the add button carries the variant id
    const btn = scope.querySelector("[data-vpills-add]");
    if (btn && btn.dataset.variantId) {
      return { id: parseInt(btn.dataset.variantId, 10), quantity: 1 };
    }
    return null;
  }

  document.addEventListener("click", function (e) {
    // ── Individual add ──
    const addBtn = e.target.closest("[data-vpills-add]");
    if (addBtn && !addBtn.hasAttribute("data-vpills-add-all")) {
      const scope = addBtn.closest("[data-vpills-scope]");
      if (!scope) return; // not a pill-managed button
      e.preventDefault();
      e.stopPropagation();
      const vp = scope.querySelector("variant-pills");
      if (vp && !vp.variantId) {
        vp.flashError();
        toast(addBtn.dataset.selectMsg || "Please select a size");
        return;
      }
      const item = itemFromScope(scope);
      if (!item) return;
      const c = cart();
      if (!c) {
        window.location.href = "/cart/" + item.id + ":1";
        return;
      }
      addBtn.classList.add("loading");
      addBtn.setAttribute("aria-busy", "true");
      c.add({ items: [item] }).finally(function () {
        addBtn.classList.remove("loading");
        addBtn.removeAttribute("aria-busy");
      });
      return;
    }

    // ── Combined add-all ──
    const allBtn = e.target.closest("[data-vpills-add-all]");
    if (allBtn) {
      const root = allBtn.closest("[data-vpills-all-scope]");
      if (!root) return;
      e.preventDefault();
      e.stopPropagation();
      const scopes = Array.prototype.slice.call(
        root.querySelectorAll("[data-vpills-scope]")
      );
      const missing = [];
      const items = [];
      scopes.forEach(function (s) {
        const it = itemFromScope(s, missing);
        if (it) items.push(it);
      });
      if (missing.length) {
        missing.forEach(function (vp) {
          vp.flashError();
        });
        missing[0].scrollIntoView({ behavior: "smooth", block: "center" });
        toast(allBtn.dataset.selectMsg || "Please select a size for every item");
        return;
      }
      if (!items.length) return;
      const c = cart();
      if (!c) {
        // Fallback to the /cart permalink (allBtn is an <a href="/cart/…">)
        if (allBtn.getAttribute("href")) window.location.href = allBtn.getAttribute("href");
        return;
      }
      allBtn.classList.add("loading");
      allBtn.setAttribute("aria-busy", "true");
      c.add({ items: items }).finally(function () {
        allBtn.classList.remove("loading");
        allBtn.removeAttribute("aria-busy");
      });
      return;
    }
  });
})();
